{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "title": "ContactForm",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "title",
    "highlight",
    "introHtml",
    "submitLabel"
  ],
  "properties": {
    "title": {
      "title": "Title",
      "type": "string",
      "maxLength": 120
    },
    "highlight": {
      "title": "Highlighted title part",
      "type": "string",
      "maxLength": 120
    },
    "introHtml": {
      "title": "Intro text",
      "type": "string",
      "maxLength": 4000,
      "x-ui": "richtext"
    },
    "submitLabel": {
      "title": "Submit button",
      "type": "string",
      "maxLength": 40
    },
    "successHref": {
      "title": "Thank-you page",
      "type": "string",
      "maxLength": 500,
      "pattern": "^(|page:[0-9a-fA-F-]{36}|/[^\\s]*|https?://[^\\s]+|mailto:[^\\s]+|tel:[+0-9 ]+|#[A-Za-z0-9_-]*)$",
      "x-ui": "link"
    }
  }
}
